export default {
  SET_LINKS: (state, payload) => {
    state.links = payload;
  },
  SET_PERMISSIONS: (state, payload) => {
    state.permissions = payload;
  },
  SET_REPORT_CONSUMPTION_USAGES: (state, payload) => {
    state.consumptionUsages = payload;
  },
  SET_REPORT_CONSUMPTION_USAGES_DETAILS: (state, payload) => {
    state.consumptionUsagesDetails = payload;
  },
  SET_REPORT_CONSUMPTION_USAGES_DETAILS_PAGINATION: (state, payload) => {
    state.consumptionUsagesPagination = payload;
  },
  SET_CONSUMPTION_REPORT_USAGES_DOWNLOAD_URL: (state, payload) => {
    state.consumptionReportUsagesDownloadURL = payload;
  },
};
